import React from 'react';

import { CurrentUserRetailerNetworkUserFragment, OpenCommerceUserFragment } from '@occc/graphql';

export type AppContextValue = {
  user: OpenCommerceUserFragment | null;
  retailerNetworkHighestRoleUser: CurrentUserRetailerNetworkUserFragment | null;
};

export const AppContext = React.createContext<AppContextValue>({
  user: null,
  retailerNetworkHighestRoleUser: null,
});
